import MeuFinanciamento from '../components/templates/MeuFinanciamento';

export default function MeuFinanciamentoPage() {
  return <MeuFinanciamento />;
}
